import { BlogSection } from "@/types/blog";

export const entwicklung: BlogSection = {
  id: "entwicklung-ermoeglichen",
  title: "Entwicklung ermöglichen statt nur Ergebnisse fordern",
  content: `
    <p>Wer nur Leistung misst, bekommt Anpassung.<br/>
    Wer Entwicklung fördert, bekommt Verantwortung.</p>

    <p>Im Alltag heißt das oft:</p>

    <blockquote>
      <p><em>Woran möchtest du dieses Jahr wachsen?</em></p>
      <p><em>Was traust du dir noch nicht zu?</em></p>
      <p><em>Wie kann ich dich unterstützen?</em></p>
    </blockquote>

    <p>Solche Gespräche verändern mehr als jede Zielvereinbarung.</p>
  `
};
